import { ReactElement } from "react";
import { IPurchaseCardProps } from "../../types";
import AccordionSection from "@common/components/thirdParty/mantine/accordion/AccordionSection";
import TitleWithIcon from "@common/components/thirdParty/mantine/text/TitleWithIcon";
import { Card, Flex, Stack, Text } from "@mantine/core";
import IconCoin from "@common/components/icons/IconCoin";
import { getPrettyPlanName, getPrettyPlanTier } from "@stores/purchases/utils";
import { isMonthlyPlan } from "@stores/plans/utils";
import TextInfos from "@components/layout/TextInfos";
import { formatDate } from "@utils/date";
import { IPurchase } from "@stores/purchases/types";

export default function CanceledSubscriptionSection({
  purchase,
}: Pick<IPurchaseCardProps, "purchase">): ReactElement {
  const { subscription, hosted_instance, product } = purchase;
  const { plan } = product;
  const { canceled_at } = subscription;

  return canceled_at || hosted_instance?.deleted_at ? (
    <AccordionSection>
      <Flex align="center" direction="row" mb="sm">
        <TitleWithIcon
          icon={<IconCoin size={13} />}
          title={`${getPrettyPlanName(purchase)} ${
            isMonthlyPlan(plan) ? " (Monthly)" : ""
          }`}
          order={3}
          size="h6"
        />
      </Flex>

      <Stack spacing="xs" w="100%">
        {canceled_at && (
          <TextInfos text1="Canceled" text2={formatDate(canceled_at, "long")} />
        )}

        {hosted_instance?.deleted_at && (
          <TextInfos
            text1="Deleted"
            text2={formatDate(hosted_instance.deleted_at, "long")}
          />
        )}
      </Stack>
    </AccordionSection>
  ) : (
    <></>
  );
}

export function CanceledSubscriptionCard({
  purchase,
  extra,
}: {
  purchase: IPurchase;
  extra?: React.ReactNode;
}) {
  const { subscription, hosted_instance, product } = purchase;
  const { plan } = product;
  const { canceled_at } = subscription;

  return (
    <Card withBorder mb="sm">
      <Flex align="center" direction="row" mb="sm">
        <Text fw={700}>{`${getPrettyPlanTier(plan.alias)} Plan`}</Text>
      </Flex>

      <Stack spacing="xs" w="100%">
        {extra}
        {canceled_at && (
          <TextInfos text1="Canceled" text2={formatDate(canceled_at, "long")} />
        )}

        {hosted_instance?.deleted_at && (
          <TextInfos
            text1="Deleted"
            text2={formatDate(hosted_instance.deleted_at, "long")}
          />
        )}
      </Stack>
    </Card>
  );
}
